var Link = require('react-router').Link;
var React = require('react');
var cx = require('classnames');

var UserStore = require('../../stores/UserStore');

var MenuItem = React.createClass({
    propTypes: {
        icon: React.PropTypes.string.isRequired,
        route: React.PropTypes.string.isOptional,
        externalUrl: React.PropTypes.string.isOptional
    },
    getInitialState: function () {
        return { opened: false }
    },
    mouseEnter: function (e) {
        this.setState({ opened: true });
    },
    mouseLeave: function () {
        this.setState({ opened: false });
    },
    render: function () {
        return <li onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} className={cx({opened: this.state.opened})}>
            {this.props.route ?
                <Link to={this.props.route}><i className={cx('fa fa-2x', this.props.icon)} /> <span>{this.props.children}</span></Link> :
                <a href={this.props.externalUrl} target="_blank"><i className={cx('fa fa-2x', this.props.icon)} /> <span>{this.props.children}</span></a>}
        </li>;
    }
})
module.exports = MenuItem;



// WEBPACK FOOTER //
// ./app/components/Layout/MenuItem.js